// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedAlarmMediumAlarmDefault_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4.69616L2.50261 21H21.4974L12 4.69616ZM13.1222 2.64914C12.618 1.7836 11.382 1.78359 10.8778 2.64914L0.182839 21.0089C-0.329799 21.8889 0.296386 23 1.30499 23H22.695C23.7036 23 24.3298 21.8889 23.8172 21.0089L13.1222 2.64914Z" class="svg-bg"/>
  <path d="M23.5001 11.694C23.8233 10.8254 23.9999 9.88552 23.9999 8.9044C23.9999 4.90805 21.0696 1.59611 17.2404 1L16.7775 2.95433C19.7239 3.33563 21.9999 5.85422 21.9999 8.9044C21.9999 9.61027 21.878 10.2877 21.6541 10.9167L23.5001 11.694Z" class="svg-bg"/>
  <path d="M20.7304 10.5278C20.9051 10.0188 20.9999 9.47265 20.9999 8.9044C20.9999 6.32736 19.0503 4.20568 16.5455 3.93383L16.0786 5.90541C17.6991 5.94715 18.9999 7.27386 18.9999 8.9044C18.9999 9.19746 18.9579 9.48071 18.8795 9.74845L20.7304 10.5278Z" class="svg-bg"/>
</svg>
`;
const _s64IconSvg = html `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M41.5879 16.7951L42.1055 14.8633C42.7637 15.0396 43.3944 15.2674 43.9944 15.5412C48.63 17.6561 51.4344 22.5134 50.9482 27.5854C50.8852 28.2419 50.7672 28.902 50.5908 29.5602L48.6589 29.0426C48.6597 29.0398 48.6604 29.0371 48.6611 29.0343C49.907 24.3691 47.6397 19.5918 43.482 17.513C42.8881 17.216 42.2556 16.9742 41.5893 16.7955C41.5888 16.7954 41.5883 16.7953 41.5879 16.7951ZM42.5855 19.3013C42.11 19.0635 41.6037 18.8699 41.0702 18.727L40.5526 20.6588C40.5534 20.659 40.5542 20.6593 40.555 20.6595C43.5543 21.4644 45.4102 24.4056 44.9241 27.4067C44.8917 27.6069 44.8488 27.8073 44.7952 28.0073L46.7271 28.5249L46.7291 28.5172C46.9065 27.8527 46.9948 27.1853 47.0013 26.5279C47.03 23.6252 45.465 20.9146 42.9368 19.4881C42.8217 19.4231 42.7046 19.3608 42.5855 19.3013ZM47.5913 46L32 18.0999L16.4088 46L47.5913 46ZM33.7459 17.1242C32.9827 15.7584 31.0174 15.7584 30.2541 17.1242L14.6629 45.0244C13.9179 46.3575 14.8816 48 16.4088 48H47.5913C49.1185 48 50.0822 46.3575 49.3372 45.0244L33.7459 17.1242Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedAlarmMediumAlarmDefault is a generated icon component.
 */
let IconMedAlarmMediumAlarmDefault = IconMedAlarmMediumAlarmDefault_1 = class IconMedAlarmMediumAlarmDefault extends IconBaseElement {
    render() {
        return html `${IconMedAlarmMediumAlarmDefault_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedAlarmMediumAlarmDefault.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s64IconSvg],
    ['s40', _s64IconSvg],
    ['s48', _s64IconSvg],
    ['s64', _s64IconSvg],
    ['s72', _s64IconSvg],
    ['s80', _s64IconSvg],
]);
IconMedAlarmMediumAlarmDefault = IconMedAlarmMediumAlarmDefault_1 = __decorate([
    customElement('zui-icon-med-alarm-medium-alarm-default')
], IconMedAlarmMediumAlarmDefault);
export { IconMedAlarmMediumAlarmDefault };
